/* eslint-disable no-param-reassign */
import _ from 'lodash';
import constants from '../../helpers/constants';
import helpers from './helpers';

export default {
  setValuesLoaded(state, payload) {
    state.valuesLoaded = payload;
  },
  setStaticColumns(state, payload) {
    state.staticColumns = helpers.prepareOptionsLocale(payload);
  },
  setJiraColumns(state, payload) {
    state.jiraColumns = payload;
  },
  setCustomColumns(state, payload) {
    const columns = helpers.prepareCustomColumnsData(payload);

    const columnsMap = columns.reduce((acc, item) => {
      const { id } = item;

      if (!acc[id]) {
        acc[id] = item;
      }

      return acc;
    }, {});

    state.columns = columns;
    state.columnsMap = columnsMap;
  },
  setProjectColumns(state, payload) {
    state.projectColumns = payload;
  },
  setProjectColumnsValues(state, payload) {
    const projects = _.cloneDeep(state.projectColumns);

    const loadedDataMap = {};

    payload.forEach(pr => {
      loadedDataMap[pr.id] = pr.values;
    });

    projects.forEach(project => {
      if (!project.values) {
        project.values = loadedDataMap[project.id];
      }
    });

    state.projectColumns = projects;
  },
  addCustomColumn(state, column) {
    state.columns.push(column);
    const columnsMap = {
      ...state.columnsMap,
      [column.id]: column,
    };

    state.columnsMap = columnsMap;
  },
  updateCustomColumn(state, payload) {
    const index = state.columns.indexOf(state.columns.find(col => col.id === payload.columnId));

    if (index === -1) return;

    const updated = helpers.prepareCustomColumnsData([payload.updated]);

    const columnsMap = {
      ...state.columnsMap,
      [updated[0].id]: updated[0],
    };

    state.columns[index] = {
      ...state.columns[index],
      ...updated[0],
    };
    state.columnsMap = columnsMap;
  },
  removeCustomColumn(state, columnId) {
    const index = state.columns.indexOf(state.columns.find(col => col.id === +columnId));

    if (index === -1) return;

    state.columns.splice(index, 1);
    state.projectColumns.forEach((project, i) => {
      const columns = [...project.columns];
      const columnIndex = columns.indexOf(columns.find(col => col.id === +columnId));

      if (columnIndex === -1) return;

      columns.splice(columnIndex, 1);
      project.columns = columns;
      state.projectColumns[i] = {
        ...state.projectColumns[i],
        ...project,
      };
    });

    const columnsMap = state.columnsMap;

    delete columnsMap[columnId];

    state.columnsMap = columnsMap;
  },
  addProject(state, payload) {
    const { data, projectId } = payload;
    let projectData = data;

    if (!projectData) {
      projectData = {
        columns: [],
        id: projectId,
        values: {},
      };
    }

    if (!state.projectColumns.find(o => o.id === projectId)) {
      state.projectColumns.push(projectData);
    }
  },
  updateProject(state, payload) {
    const index = state.projectColumns.indexOf(state.projectColumns.find(pr => pr.id === +payload.projectId));

    if (index === -1) return;

    const updated = {
      ...payload.updated,
      id: +payload.projectId,
    };

    state.projectColumns[index] = {
      ...state.projectColumns[index],
      ...updated,
    };
  },
  removeProject(state, projectId) {
    state.projectColumns.filter(pr => pr.id !== projectId);
  },
  changeCustomValues(state, payload) {
    // payload = {
    //   task: { id: 0, gantt_id: 0},
    //   columnId: 0,
    //   value: [] || 'String',
    // }

    const { task, columnId, value } = payload;
    const project = state.projectColumns.find(pr => pr.id === task.gantt_id);

    if (!project) return;

    const index = state.projectColumns.indexOf(state.projectColumns.find(pr => pr.id === project.id));
    const taskValues = [];
    const newValues = Array.isArray(value) ? value : [value];
    const columnType = state.columns.find(col => col.id === columnId).type;

    newValues.forEach(item => {
      let newValue;

      if (columnType === 2) {
        newValue = item;
      } else {
        newValue = Number.isNaN(+item) ? item : +item;
      }

      taskValues.push({
        // gantt_id: task.gantt_id,
        column_id: columnId,
        task_id: task.id,
        task_value: newValue,
      });
    });

    if (project.values[task.id]) {
      project.values[task.id].forEach(item => {
        if (item.column_id !== columnId) {
          taskValues.push(item);
        }
      });
    }

    project.values[task.id] = taskValues;
    state.projectColumns[index] = project;
  },
  updateUserCustomValues(state, payload) {
    // payload = {
    //   userCustomValues: [
    //     {
    //       taskId: payload.id,
    //       ganttId: payload.ganttId,
    //       customFields: [
    //         {
    //           customColumnId: payload.customColumnId,
    //           isOptions: payload.isOptions,
    //           value: payload.value,
    //         }
    //       ],
    //     },
    //   ],
    // };

    const groupByGanttId = _.groupBy(payload.userCustomValues, 'ganttId');

    Object.keys(groupByGanttId).forEach(ganttId => {
      const project = state.projectColumns.find(pr => pr.id === +ganttId);

      if (!project) return;

      const columnTypeMap = new Map(state.columns.map(col => [col.id, col.type]));

      payload.userCustomValues.forEach(taskCustomValueData => {
        taskCustomValueData.customFields.forEach(customField => {
          const newValues = Array.isArray(customField.value) ? customField.value : [customField.value];
          const columnType = columnTypeMap.get(customField.customColumnId);

          const taskValues = newValues.map(item => {
            let newValue;

            if (columnType === 2) {
              newValue = item;
            } else {
              newValue = Number.isNaN(+item) ? item : +item;
            }

            return {
              column_id: customField.customColumnId,
              task_id: taskCustomValueData.taskId,
              task_value: newValue,
            };
          });

          if (project.values[taskCustomValueData.taskId]) {
            project.values[taskCustomValueData.taskId].forEach(item => {
              if (item.column_id !== customField.customColumnId) {
                taskValues.push(item);
              }
            });
          }

          project.values[taskCustomValueData.taskId] = taskValues;
        });
      });

      const projectIndex = state.projectColumns.findIndex(pr => pr.id === project.id);

      state.projectColumns[projectIndex] = project;
    });
  },
  updateUserCustomValuesTasksIds(state, payload) {
    // payload = {
    //   tasks: [
    //     {
    //       sourceTaskId: payload.sourceTaskId,
    //       targetTaskId: payload.targetTaskId,
    //       ganttId: payload.ganttId,
    //     },
    //   ],
    // };

    const groupByGanttId = _.groupBy(payload.tasks, 'ganttId');

    _.forOwn(groupByGanttId, (tasks, ganttId) => {
      const tasksMap = _.keyBy(tasks, 'sourceTaskId');
      const project = state.projectColumns.find(pr => pr.id === +ganttId);

      if (!project) {
        return;
      }

      _.forOwn(project.values, (values, taskId) => {
        if (tasksMap[taskId]) {
          const targetTaskId = tasksMap[taskId].targetTaskId;
          const newValues = values.map(item => ({ ...item, task_id: targetTaskId }));

          project.values[targetTaskId] = newValues;
          delete project.values[taskId];
        }
      });
    });
  },
  addColumnsToProjects(state, payload) {
    const { columnIds, projectIds } = payload;
    const projects = [];

    state.projectColumns.forEach(project => {
      if (projectIds.includes(project.id)) {
        columnIds.forEach(id => {
          if (!project.columns.includes(id)) project.columns.push(id);
        });
      }

      projects.push(project);
    });

    state.projectColumns = projects;
  },
  removeColumnFromProjects(state, payload) {
    const { columnId, projectIds } = payload;
    const projects = [];

    state.projectColumns.forEach(project => {
      if (projectIds.includes(project.id)) {
        const columnIndex = project.columns.indexOf(columnId);

        if (columnIndex >= 0) {
          project.columns.splice(columnIndex, 1);
        }
      }

      projects.push(project);
    });

    state.projectColumns = projects;
  },
  removeResourceOptionById(state, resourceId) {
    const columnsAndOptions = [];

    state.columns.forEach((column, i) => {
      if (column.type === constants.CUSTOM_COLUMNS_TYPES.resources.id) {
        const optionData = column.options.find(opt => opt.resource_id === resourceId);

        if (optionData) {
          columnsAndOptions.push({
            columnId: column.id,
            optionId: optionData.id,
          });
        }
        column.options = column.options.filter(opt => opt.resource_id !== resourceId);

        state.columns[i] = {
          ...state.columns[i],
          ...column,
        };
      }
    });

    state.projectColumns.forEach((project, i) => {
      const hasResourceColumn = project.columns.find(columnId => columnsAndOptions.find(item => item.columnId === columnId));

      if (hasResourceColumn) {
        const values = {};

        Object.values(project.values).forEach(taskData => {
          let taskId;
          const filtered = taskData.filter(item => {
            taskId = item.task_id;
            if (columnsAndOptions.find(obj => obj.optionId === item.task_value)) {
              return;
            }

            return item;
          });

          values[taskId] = filtered;
        });

        project.values = values;

        state.projectColumns[i] = {
          ...state.projectColumns[i],
          ...project,
        };
      }
    });
  },
  removeResourceOptionFromProject(state, payload) {
    const { resourceId, projectId } = payload;
    const columnsAndOptions = [];
    const projectColumnIds = state.projectColumns.find(item => +item.id === +projectId).columns || [];

    state.columns.forEach((column, i) => {
      const projectColumnId = projectColumnIds.find(id => +id === +column.id);

      if (column.type === constants.CUSTOM_COLUMNS_TYPES.resources.id) {
        const optionData = column.options.find(opt => opt.resource_id === resourceId);

        if (optionData) {
          columnsAndOptions.push({
            columnId: column.id,
            optionId: optionData.id,
          });
        }

        if (optionData && projectColumnId) {
          column.options = column.options.filter(opt => opt.resource_id !== resourceId);
          state.columns[i] = {
            ...state.columns[i],
            ...column,
          };
        }
      }
    });

    state.projectColumns.forEach((project, i) => {
      const hasResourceColumn = project.columns.find(columnId => columnsAndOptions.find(item => item.columnId === columnId));

      if (hasResourceColumn && project.id === projectId) {
        const values = {};

        Object.entries(project.values).forEach(([taskId, data]) => {
          const filteredData = data.filter(item => {
            if (!(columnsAndOptions.find(obj => obj.optionId === item.task_value))) {
              return item;
            }
          });

          values[taskId] = filteredData;
        });

        project.values = values;

        state.projectColumns[i] = {
          ...state.projectColumns[i],
          ...project,
        };
      }
    });
  },
};
